import { useCallback } from 'react'
import { Contract } from 'web3-eth-contract'

import { 
  commonStakeERC721EarnERC20Stake,
  commonStakeERC721EarnERC20BatchStake,
  commonStakeERC721EarnBakeBatchStake,
  commonStakeERC721EarnBakeStake
} from '../../sushi/utils'
import { simpleStakeERC721EarnERC20BatchStake, simpleStakeERC721EarnERC20Stake } from '../../sushi/simpleStakeERC721EarnERC20'
import { MINTTOKEN } from '../../constants/bakery'

// hooks
import { useActiveWeb3React } from '../'

const useStakeNFT = (lpTokenAddress: string, masterContract: Contract, earnTokenName?: string) => {
  const {account} = useActiveWeb3React()
  
  const handleStake = useCallback(
    async (tokenIds: any) => {
      let txHash
      if (tokenIds.length > 1) {
        switch (earnTokenName) {
          case MINTTOKEN.TKONFTSTAKE:
          case MINTTOKEN.BMONCNFTSTAKE:
            txHash = await commonStakeERC721EarnERC20BatchStake(
              masterContract,
              lpTokenAddress,
              tokenIds,
              account,
            )
            break
          case MINTTOKEN.TOYNFTSTAKE:
            txHash = await simpleStakeERC721EarnERC20BatchStake(
              masterContract,
              tokenIds,
              account,
            )
            break
          case MINTTOKEN.BMMNFTSTAKE:
            txHash = await commonStakeERC721EarnBakeBatchStake(
              masterContract,
              tokenIds,
              account,
            )
            break
          default:
            txHash = await commonStakeERC721EarnERC20BatchStake(
              masterContract,
              lpTokenAddress,
              tokenIds,
              account,
            )
            break
        }
      } else {
        switch (earnTokenName) {
          case MINTTOKEN.TKONFTSTAKE:
          case MINTTOKEN.BMONCNFTSTAKE:
            txHash = await commonStakeERC721EarnERC20Stake(
              masterContract,
              lpTokenAddress,
              ...tokenIds,
              account,
            )
            break
          case MINTTOKEN.TOYNFTSTAKE:
            txHash = await simpleStakeERC721EarnERC20Stake(
              masterContract,
              ...tokenIds,
              account,
            )
            break
          case MINTTOKEN.BMMNFTSTAKE:
            txHash = await commonStakeERC721EarnBakeStake(
              masterContract,
              ...tokenIds,
              account,
            )
            break
          default:
            txHash = await commonStakeERC721EarnERC20Stake(
              masterContract,
              lpTokenAddress,
              ...tokenIds,
              account,
            )
            break
        }
      }
      console.log(txHash)
      return txHash
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [account, lpTokenAddress, masterContract],
  )

  return { onStakeNFT: handleStake }
}

export default useStakeNFT
